import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _excluded = ["title", "extra", "children"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export var Context = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  font-weight: normal;\n"])));
export var Title = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  font-size: 23px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
export var Extra = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  gap: 10px;\n"])));
export var Layout = /*#__PURE__*/forwardRef((props, ref) => {
  var title = props.title,
    extra = props.extra,
    children = props.children,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs("div", _extends({
    ref: ref
  }, other, {
    children: [/*#__PURE__*/_jsxs(Title, {
      children: [/*#__PURE__*/_jsxs("span", {
        children: [" ", title, " "]
      }), /*#__PURE__*/_jsx(Extra, {
        children: extra
      })]
    }), /*#__PURE__*/_jsx(Context, {
      children: children
    })]
  }));
});
export var StyledLayout = styled(Layout)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  font-weight: bold;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  flex: 1;\n  gap: 10px;\n  width: 0;\n  ", "\n"])), props => props.overflow && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      overflow: ", ";\n    "])), props.overflow));